var render = function render(){var _vm=this,_c=_vm._self._c;return _c('img',{staticClass:"logo__image",attrs:{"src":_vm.env.logoUrl,"alt":"Betika logo"}})
}
var staticRenderFns = []

export { render, staticRenderFns }